// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB2iw1GviW_P0uTGSG4MK2sBIv1hJemPYk",
  authDomain: "flourish-thyself.firebaseapp.com",
  projectId: "flourish-thyself",
  storageBucket: "flourish-thyself.appspot.com",
  messagingSenderId: "377417174077",
  appId: "1:377417174077:web:4cc3ed0fc713c5d8176e54",
  measurementId: "G-L1QRND7SFW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);